import { Box, Button, Icon, Text, useToggle } from '@factorialco/deprecated-design-system'

import Modal from 'modules/core/components/Modal'
import i18n from 'modules/core/lib/i18n'

import RulesDescription from '../RulesConfiguration/RulesDescription'

interface Props {
  description: string | null | undefined
}

export const SeeRules = ({ description }: Props) => {
  const [open, toggle] = useToggle(false)

  if (!description) return null
  return (
    <Box
      paddingLeft="s24"
      paddingBottom="s16"
      flexDirection="row"
      gap="s8"
      alignItems="center"
      onClick={toggle(true)}
      cursor="pointer"
    >
      <Text.Normal>
        {i18n.t('settings.approvals.approval_request_view.approval_history.see_smart_rules')}
      </Text.Normal>
      <Icon.Small icon="arrow-right" />
      {open && (
        <Modal
          illustration="add-block"
          title={i18n.t(
            'settings.approvals.approval_request_view.approval_history.resource_auto_approved'
          )}
          description={
            <Box gap="s16">
              <Box background="grey200" borderRadius={{ all: 'abs004' }} padding="s24">
                <RulesDescription description={description}></RulesDescription>
              </Box>
            </Box>
          }
          onClose={toggle(false)}
          footer={
            <Button type="secondary" onClick={toggle(false)}>
              {i18n.t('common.close')}
            </Button>
          }
        />
      )}
    </Box>
  )
}
